import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import { toastGuidGroupQueryKeys } from './useToastGuidGroups';

export interface DeleteToastGuidGroupVariables {
  id: string;
}

export function useDeleteToastGuidGroup(
  options?: UseMutationOptions<void, Error, DeleteToastGuidGroupVariables>,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['toastGuidGroup', 'delete'],
    mutationFn: async ({ id }: DeleteToastGuidGroupVariables) => {
      return service.deleteToastGuidGroup(id);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: toastGuidGroupQueryKeys.all });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
